__turbopack_context__.v({
  "caption": "Prose-module___sV0yW__caption",
  "centered": "Prose-module___sV0yW__centered",
  "deck": "Prose-module___sV0yW__deck",
  "dropcap": "Prose-module___sV0yW__dropcap",
  "eyebrow": "Prose-module___sV0yW__eyebrow",
  "footnotes": "Prose-module___sV0yW__footnotes",
  "lead": "Prose-module___sV0yW__lead",
  "prose": "Prose-module___sV0yW__prose",
  "pullquote": "Prose-module___sV0yW__pullquote",
  "small": "Prose-module___sV0yW__small",
  "technical": "Prose-module___sV0yW__technical",
});
